export const state = {
  isFormal: true,
  factorList: [],
  selectedRow: {},
  customersList: [],
  companyList: [],
  productsList: [],
  details: [],
  provinceData: [],
  cityData: [],
  invoiceDefaults: [],
  updateCustomerList: null,
  updateProductList: null,
  invoiceList: [],
  agentList: [],
  selectedProduct: null,
  selectedAgent: null,
  editedInvoiceItems: [],
  deletedInvoiceItems: [],
}

export const mutations = {
  SET_EDITED_INVOICE_ITEMS(state, id) {
    id = Number(id)
    if (state.editedInvoiceItems.length === 0) {
      state.editedInvoiceItems.push(id)
    } else {
      const isDuplicate = state.editedInvoiceItems.find(_id => _id === id)
      if (!isDuplicate) {
        state.editedInvoiceItems.push(id)
      }
    }
  },
  SET_DELETED_INVOICE_ITEMS(state, id) {
    id = Number(id)
    if (state.deletedInvoiceItems.length === 0) {
      state.deletedInvoiceItems.push(id)
    } else {
      const isDuplicate = state.deletedInvoiceItems.find(_id => _id === id)
      if (!isDuplicate) {
        state.deletedInvoiceItems.push(id)
      }
    }
  },
  SET_SELECTED_PRODUCT(state, payload) {
    state.selectedProduct = payload
  },
  SET_SELECTED_AGENT(state, payload) {
    state.selectedAgent = payload
  },
  SET_AGENT_LIST(state, payload) {
    state.agentList = payload
  },
  UPDATE_PRODUCT_LIST(state, bool) {
    state.updateProductList = bool
  },
  UPDATE_CUSTOMER_LIST(state, bool) {
    state.updateCustomerList = bool
  },
  SET_INVOICE_DEFAULTS(state, payload) {
    state.invoiceDefaults = payload
  },
  SET_ISFORMAL(state, bool) {
    state.isFormal = bool
  },
  SET_FACTOR_LIST(state, payload) {
    state.factorList = payload
  },
  SET_SELECTED_ROW(state, payload) {
    state.selectedRow = payload
  },
  SET_CUSTOMERS_LIST(state, payload) {
    state.customersList = payload
  },
  SET_COMPANY_LIST(state, payload) {
    state.companyList = payload
  },
  SET_PAGINATION_CUSTOMER_LIST(state, payload) {
    state.customersList.push(...payload)
  },
  SET_PAGINATION_COMPANY_LIST(state, payload) {
    state.companyList.push(...payload)
  },
  SET_PAGINATION_PRODUCT_LIST(state, payload) {
    state.productsList.push(...payload)
  },
  SET_SEARCHED_CUSTOMER_LIST(state, payload) {
    state.customersList = []
    state.customersList = payload
  },
  SET_SEARCHED_COMPANY_LIST(state, payload) {
    state.companyList = []
    state.companyList = payload
  },
  SET_INVOICE_LIST(state, payload) {
    state.invoiceList.push(payload)
  },
  FLUSH_INVOICE_LIST(state) {
    state.invoiceList = []
  },
  EDIT_INVOICE_LIST(state, payload) {
    state.invoiceList.splice(payload.index, 1, payload)
  },
 
  NEW_DETAIL(state, payload) {
    state.details.push(payload)
  },
  NEW_PRODUCT_LIST(state, payload) {
    state.productsList = payload
  },
  SET_PROVINCE_DATA(state, payload) {
    state.provinceData = payload
  },
  SET_CITY_DATA(state, payload) {
    state.cityData = payload
  },
  UPDATED_INVOICE_LIST(state, payload) {
    state.invoiceList = payload
  },
}

export const actions = {
  setUpdatedInvoiceList({ commit }, payload) {
    commit('UPDATED_INVOICE_LIST', payload)
  },
  setEditedInvoiceItems({ commit }, payload) {
    commit('SET_EDITED_INVOICE_ITEMS', payload)
  },
  setDeletedInvoiceItems({ commit }, payload) {
    commit('SET_DELETED_INVOICE_ITEMS', payload)
  },
  setAgentList({ commit }, payload) {
    commit('SET_AGENT_LIST', payload)
  },
  flushInvoiceList({ commit }) {
    commit('FLUSH_INVOICE_LIST')
  },
  setUpdateProductList({ commit }, bool) {
    commit('UPDATE_PRODUCT_LIST', bool)
  },
  updateCustomerList({ commit }, bool) {
    commit('UPDATE_CUSTOMER_LIST', bool)
  },
  setInvoiceDefaults({ commit }, payload) {
    commit('SET_INVOICE_DEFAULTS', payload)
  },
  setInvoiceDefaultValues({ commit }, payload) {
    commit('SET_INVOICE_LIST_DEFAULT_VALUES', payload)
  },
  setInvoiceDefaultTableHeader({ commit }, payload) {
    commit('SET_INVOICE_DEFAULT_TABLE_HEADER', payload)
  },
  setIsFormal({ commit }, bool) {
    commit('SET_ISFORMAL', bool)
  },
  setFactorList({ commit }, payload) {
    commit('SET_FACTOR_LIST', payload)
  },
  setSelectedRow({ commit }, payload) {
    commit('SET_SELECTED_ROW', payload)
  },
  setCustomersList({ commit }, payload) {
    commit('SET_CUSTOMERS_LIST', payload)
  },
  setPaginationCustomersList({ commit }, payload) {
    commit('SET_PAGINATION_CUSTOMER_LIST', payload)
  },
  setPaginationCompanyList({ commit }, payload) {
    commit('SET_PAGINATION_COMPANY_LIST', payload)
  },
  setPaginationProductList({ commit }, payload) {
    commit('SET_PAGINATION_PRODUCT_LIST', payload)
  },
  setSearchedCustomersList({ commit }, payload) {
    commit('SET_SEARCHED_CUSTOMER_LIST', payload)
  },
  setSearchedCompanyList({ commit }, payload) {
    commit('SET_SEARCHED_COMPANY_LIST', payload)
  },
  setInvoiceList({ commit }, payload) {
    commit('SET_INVOICE_LIST', payload)
  },
  editInvoiceList({ commit }, payload) {
    commit('EDIT_INVOICE_LIST', payload)
  },
  setCompanyList({ commit }, payload) {
    commit('SET_COMPANY_LIST', payload)
  },
  setNewDetail({ commit }, payload) {
    commit('NEW_DETAIL', payload)
  },
  setNewProductList({ commit }, payload) {
    commit('NEW_PRODUCT_LIST', payload)
  },
  setProvinceData({ commit }, payload) {
    commit('SET_PROVINCE_DATA', payload)
  },
  setCityData({ commit }, payload) {
    commit('SET_CITY_DATA', payload)
  },
  setSelectedProduct({ commit }, payload) {
    commit('SET_SELECTED_PRODUCT', payload)
  },
  setSelectedAgent({ commit }, payload) {
    commit('SET_SELECTED_AGENT', payload)
  },
}
